
document.addEventListener('DOMContentLoaded' , () =>{
	
	//header height
	const content = document.querySelector('.contents');
	function contentTopSet(){
		if (!content || content.classList.contains("app-dash-page")) return;

		const searchLayer = document.querySelector('.js-search-layer');
		const header = document.querySelector('.app-header');
		const lnb = document.querySelector('.lnb');
		const isApp = document.querySelector('.is-app');

		let top = 0;

		if (header && header.offsetHeight > 0) {
			top = header.offsetHeight;

		} else if (lnb && lnb.offsetHeight > 0) {
			top = lnb.offsetHeight;
		}

		if(isApp){
			// alert('app');
			top = top - 5;

			content.style.marginTop = 'calc(' + top + 'px' + ' + env(safe-area-inset-top))';
		}else{
			// alert('web');
			content.style.marginTop = top + 'px';

			if (searchLayer && window.innerWidth >= 768) {
				searchLayer.style.top = top + 'px';
			}
		}
	}
	contentTopSet();

	if (document.querySelector('.app-header')) {	
		const header = document.querySelector('.app-header');
		let headerH = document.getElementById('app-header').offsetHeight;
	
		window.addEventListener('scroll', () => {
			if (window.scrollY >= headerH) {
				header.classList.add('scroll-fixed');
			} else {
				header.classList.remove('scroll-fixed');
			}
		});
	}

	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');

	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}
	
    //default-swiper
    if(document.querySelector('.js-default-swiper')){
		const defaultSwiper = document.querySelectorAll('.js-default-swiper');

		defaultSwiper.forEach(el => {
			let _defaultSwiper = new Swiper(el, {
				slidesPerView: 'auto',
			});
		});
    }

	// footer - floating button
	if(document.querySelector('.js-floating-button')){
		const floatingButton = document.querySelector('.js-floating-button');

		window.addEventListener('scroll' , ()=>{
			if(window.scrollY >= floatingButton.clientHeight){
				floatingButton.classList.add('scroll');
			} else {
				floatingButton.classList.remove('scroll');
			}
		})
	}

	// input only number
	if (document.querySelector('.only-number')) {
		document.querySelectorAll('input.only-number').forEach(function (input) {
			input.addEventListener('input', function () {
				this.value = this.value.replace(/[^0-9]/g, '');
			});
		});
	}
	
	if (document.querySelector('.js-search-btn')) {
		const searchBtn = document.querySelector('.js-search-btn');
		const searchArea = document.querySelector('.js-search-area');

        searchBtn.addEventListener('click', () => {
            searchArea.classList.toggle('active');
		});
	}
	if (document.querySelector('.js-filter')) {
		const filter = document.querySelector('.js-filter');
		const resetBtn = filter.querySelector('.btn--reset');
		const selects = filter.querySelectorAll('select');

		const updateSelectStyle = (select) => {
			if (select.value !== "") {
				select.classList.add('black');
			} else {
				select.classList.remove('black');
			}
		};

		const updateResetButton = () => {
			const hasSelectedValue = Array.from(selects).some(select => select.value !== "");
			
			if (hasSelectedValue) {
				resetBtn.classList.add('active');
			} else {
				resetBtn.classList.remove('active');
			}
		};

		selects.forEach(select => {
			updateSelectStyle(select);

			select.addEventListener('change', () => {
				updateSelectStyle(select);
				updateResetButton();
			});
		});

		resetBtn.addEventListener('click', () => {
			selects.forEach(select => {
				select.value = "";
				updateSelectStyle(select);
				// onchange 이벤트 강제 실행
				select.dispatchEvent(new Event('change'));
			});
			updateResetButton();
		});

		updateResetButton();
	}
});
